<template>
    <div>
        <div class="content">
            <div class="header"><span>{{l10nHeaderText | uppercase}}</span></div>
            <div class="sub-header"><span>{{l10nSubTitleText}}</span></div>
            <div class="divider"></div>
            <div class="about-content">
                <div class="section-1">
                    <div class="container">
                        <div class="left-area">
                            <jabra-body-text-binding :html="l10nLeftParagraph"></jabra-body-text-binding>
                        </div>
                        <div class="right-area">
                            <div class="area-title">
                                <span>{{l10nRightParagraphHeaderText}}</span>
                            </div>
                            <div>
                                <jabra-body-text-binding :html="l10nRightParagraph"></jabra-body-text-binding>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cards">
                        <div class="card-bg top-card">
                            <div class="area-card">
                                <div class="area-card-content">

                                    <div class="title"><span>{{l10nBookPublishingText}}</span></div>
                                    <div class="divider-2-container">
                                        <div class="divider-2"></div>
                                    </div>
                                    <div class="card-content">
                                        <jabra-body-text-binding
                                                :html="l10nBookPublishingDetails"></jabra-body-text-binding>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-bg middle-card">
                            <div class="area-card">
                                <div class="area-card-content">

                                    <div class="title">
                                        <span>{{l10nVideoLessonsText}}</span>
                                    </div>
                                    <div class="divider-2-container">
                                        <div class="divider-2"></div>
                                    </div>
                                    <div class="card-content">
                                        <jabra-body-text-binding
                                                :html="l10nVideoLessonsDetails"></jabra-body-text-binding>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-bg top-card">
                            <div class="area-card">
                                <div class="area-card-content">

                                    <div class="title">
                                        <span>{{l10nOurTeamText}}</span>
                                    </div>
                                    <div class="divider-2-container">
                                        <div class="divider-2"></div>
                                    </div>
                                    <div class="card-content">
                                        <jabra-body-text-binding
                                                :html="l10nOurTeamDetails"></jabra-body-text-binding>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-3">
                    <div class="container">
                        <div>
                            <div class="area-title">
                                <span>{{l10nBabylonianTalmudInModernLanguageText}}</span>
                            </div>
                            <div class="details">
                                <jabra-body-text-binding
                                        :html="l10nBabylonianTalmudInModernLanguageDetails"></jabra-body-text-binding>
                            </div>
                            <div class="history-button">
                                <jabra-btn dark :type="'submit'">
                                    <span class="slot-text">{{l10nHistoryOfTheTalmudText}}</span>
                                </jabra-btn>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-colored-section-container">
                    <div class="bottom-colored-section">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import helpers from '../services/helpers'

    export default {
        name: 'about',
        data: function () {
            return {}
        },
        computed: {
            l10nHeaderText() {
                return this.l10nGetter('about_title')
            },
            l10nSubTitleText() {
                return this.l10nGetter('about_sub_title')
            },
            l10nRightParagraphHeaderText() {
                return this.l10nGetter('about_right_paragraph_header')
            },
            l10nLeftParagraph() {
                return this.l10nBodyGetter('about_left_paragraph')
            },
            l10nRightParagraph() {
                return this.l10nBodyGetter('about_right_paragraph')
            },
            l10nBookPublishingDetails() {
                return this.l10nBodyGetter('book_publishing_details')
            },
            l10nVideoLessonsDetails() {
                return this.l10nBodyGetter('video_lessons_details')
            },
            l10nOurTeamDetails() {
                return this.l10nBodyGetter('our_team_details')
            },
            l10nBookPublishingText() {
                return this.l10nGetter('book_publishing')
            },
            l10nVideoLessonsText() {
                return this.l10nGetter('video_lessons')
            },
            l10nOurTeamText() {
                return this.l10nGetter('our_team')
            },
            l10nBabylonianTalmudInModernLanguageText() {
                return this.l10nGetter('babylonian_talmud_in_modern_language')
            },
            l10nBabylonianTalmudInModernLanguageDetails() {
                return this.l10nBodyGetter('babylonian_talmud_in_modern_language_details')
            },
            l10nHistoryOfTheTalmudText() {
                return this.l10nGetter('talmud_history')
            },
        },
        methods: {
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
            l10nBodyGetter(key) {
                return helpers.bodyTextGetter(this.$store, key)
            },
        },
        created() {

        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 0 0 0;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .sub-header {
        @include font-abraham(36px, $font-color-blue, 300);
        text-align: center;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .about-content {
        .section-1 {
            width: 100%;
            background-color: #e9f1f6;
            @include font-abraham(16px, $font-color-blue, 300);
            display: flex;
            justify-content: center;

            .container {
                width: 100%;
                max-width: 1000px;
                padding: 50px 0;
                display: flex;

                .left-area, .right-area {
                    $area-margin:10px;
                    width: calc(50% - #{$area-margin * 2});
                    margin: 0 $area-margin;

                    .area-title {
                        @include font-abraham(24px, $font-color-blue, 300);
                    }
                }
            }

        }

        .section-3 {
            width: 100%;
            @include font-abraham(18px, $font-color-blue, 300);
            display: flex;
            justify-content: center;

            .container {
                width: 100%;
                max-width: 1000px;
                padding: 50px 0;

                .area-title {
                    @include font-abraham(36px, $font-color-blue, 400);
                }

                .area-title, .details, .history-button {
                    display: flex;
                    justify-content: center;
                }

                .details {
                    margin: 0 0 30px 0;
                }

                .slot-text {
                    font-size: 18px;
                    line-height: 36px;
                    padding: 0 20px;
                }
            }

        }
    }

    .cards {
        margin: 200px 0 0 0;
        display: flex;
        justify-content: center;
    }

    $cards-margin: 10px;

    .card-bg {
        background: $font-color-blue;
        margin: $cards-margin;
        display: flex;
        width: calc(33% - #{$cards-margin * 2});

        &.top-card {
            align-items: flex-end;
        }

        &.middle-card {
            background: url("../assets/images/home-middle-card-bg.png");
        }
    }

    .area-card {
        background: white;
        width: 100%;
        box-shadow: 0 1px 35px 0 rgba(0, 0, 0, 0.17);
        border-left: solid $accent-1 1px;
        height: calc(100% - 10px);

    }

    .area-card-content {
        padding: 70px 0;
    }

    .title, .divider-2-container, .donate-section {
        display: flex;
        justify-content: center;
    }

    .title {
        @include font-abraham(36px, $font-color-blue, 400);
        text-align: center;
    }

    .divider-2 {
        width: 120px;
        height: 8px;
        margin: 30px 30px 45px 30px;
        background: $accent-1;
    }

    .card-content {
        @include font-abraham(18px, $font-color-blue, 300);
        line-height: 24px;
        text-align: center;
        padding: 0 40px;

    }

    .bottom-colored-section-container {
        position: relative;
        z-index: -1;
    }

    .bottom-colored-section {
        background: #e9f1f6;
        height: 270px;
        width: 100%;
        position: absolute;
        bottom: 0;
    }

</style>
